<template>
    <ui-tag-icon :icon-size="16"
        :text-size="12"
        :border="0"
        :text="restOfTime"
        iconColor="#0091FF"
        icon="fal fa-hourglass-start"
        color="#566889" 
    />
</template>

<script>

    import { uiTagIcon } from "@/components/ui/tags"

    const moment = require('moment')
    require('moment/locale/pt-br')

    moment.updateLocale('pt-br', {
        relativeTime: {
            future: '%s', // Padroniza os valores futuros em apenas numeros
            past: '-%s', // Padroniza os valores passados em apenas numeros negativos
            d: '%d', // Padroniza o retorno para dia unico em numérico
            dd: '%d' // Padroniza os dias em numérico
        }
    })

    export default {
        name: 'countDown',
        props: {
            time: {
                type: String,
                required: true
            },

            labelExpired: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {
                restOfTime: '',
                interval: null
            }
        },

        components: {
            uiTagIcon
        },

        methods: {
            countDown() {
                this.interval = setInterval(() => {
                    let nDate, nTime, lHours, lMinutes, lSeconds

                    // Pega a diferenca em milesegundos entre a data atual e a data passada
                    nDate = moment().diff(this.time)
                    // Converte os milesegundos  em um valor legivel em dias, horas, minutos e segundos. 
                    nTime = moment.duration(nDate)

                    // Caso o valor seja positivo mostra que já foi expirado
                    // Data atual - data final = positivo => expirado / negativo => existe tempo
                    if (parseInt(nDate) > 0) {

                        // Caso tenha um texto de apoio adiciona o mesmo no retorno, caso contrario retorna apenas o tempo
                        this.restOfTime = this.labelExpired ? this.labelExpired + moment(this.time).format('L [às] LTS') : moment(this.time).format('L [às] LTS')
                        // Caso já tenha vencido não é necessário manter o contador.
                        this.clear()
                    }else{

                        /**
                         * 
                         * Faz o mesmo procedimento para horas, minutos e segundos
                         * Converte o negativo em positivo
                         * Caso seja menor que 10 adicionar o 0 antes, pois sem isso ficaria [0..9] e não [00..09]
                        */
                        lHours = nTime.hours()
                        lHours = parseInt(lHours) * -1
                        lHours = lHours < 10 && lHours > 0 ? '0' + lHours : lHours

                        lMinutes = nTime.minutes()
                        lMinutes = parseInt(lMinutes) * -1
                        lMinutes = lMinutes < 10 && lMinutes > 0 ? '0' + lMinutes : lMinutes

                        lSeconds = nTime.seconds()
                        lSeconds = parseInt(lSeconds) * -1
                        lSeconds = lSeconds < 10 && lSeconds > 0 ? '0' + lSeconds : lSeconds

                        this.restOfTime = (nTime.days() * -1) + (nTime.days() == -1 ? ' Dia ' : ' Dias ') + ' e ' + lHours + ':' + lMinutes + ':' + lSeconds
                    }
                }, 1000)
            },

            start(){
                this.countDown()
            },

            clear(){
                clearInterval(this.interval)
                this.interval = null
            }
        },

        created(){
            this.start()
        }
    }
</script>